import { render, staticRenderFns } from "./MyPage.vue?vue&type=template&id=12f4f60a&scoped=true&"
import script from "./MyPage.vue?vue&type=script&lang=ts&"
export * from "./MyPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f4f60a",
  null
  
)

export default component.exports